@let list = formattedList$ | async;
<ng-container *transloco="let t">
    @if (list) {
        <div
            sticky
            [stickyTop]="50"
            class="bazis-list bazis-list_step"
        >
            @for (item of list; track $index; let i = $index) {
                <div
                    class="bazis-item"
                    [class.bazis-item_parent]="item.children"
                    [class.bazis-item--invalid]="!item.isValid"
                    [class.bazis-item--empty]="item.isEmpty"
                    [class.bazis-item--required]="item.isRequired$ | async"
                >
                    <ng-container
                        [ngTemplateOutlet]="stringTpl"
                        [ngTemplateOutletContext]="{ item: item, index: i }"
                    ></ng-container>

                    @if (item.children) {
                        @for (childItem of item.children; track $index; let j = $index) {
                            <div class="bazis-list">
                                <div
                                    class="bazis-item"
                                    [class.bazis-item--invalid]="!childItem.isValid"
                                    [class.bazis-item--empty]="childItem.isEmpty"
                                    [class.bazis-item--required]="childItem.isRequired$ | async"
                                >
                                    <ng-container
                                        [ngTemplateOutlet]="stringTpl"
                                        [ngTemplateOutletContext]="{ item: childItem, index: j }"
                                    ></ng-container>
                                </div>
                            </div>
                        }
                    }
                </div>
            }
        </div>
    } @else {
        <bazis-entity-status-list-skeleton></bazis-entity-status-list-skeleton>
    }

    <ng-template
        #stringTpl
        let-item="item"
        let-index="index"
    >
        @if (item.title || item.titleKey) {
            <bazis-step
                [signHidden]="item.children"
                [iconSign]="!item.isValid && !item.isEmpty ? 'cross-small' : 'check'"
                (click)="stepClicked(item)"
            >
                <span slot="label">
                    {{ item.title || t(item.titleKey, item.titleKeyParam) }}
                </span>

                @let isRequired = item.isRequired$ | async;
                @if (isRequired) {
                    <span
                        color="danger"
                        class="bazis-text_major"
                        >*</span
                    >
                }
            </bazis-step>
        }

        @if (item.titleEntity) {
            <bazis-step
                [signHidden]="item.children"
                [iconSign]="!item.isValid && !item.isEmpty ? 'cross-small' : 'check'"
                (click)="stepClicked(item)"
            >
                @if (item.titleEntity) {
                    <ng-container
                        [ngTemplateOutlet]="entityTemplate"
                        [ngTemplateOutletContext]="{
                            titleEntity: item.titleEntity.titleEntity,
                            titleField: item.titleEntity.titleField,
                            entityType: item.titleEntity.entityType,
                            id: item.titleEntity.id,
                            defaultTitle: item.defaultTitle,
                            defaultTitleKey: item.defaultTitleKey,
                            defaultTitleKeyParam: item.defaultTitleKeyParam,
                            isRequired$: item.isRequired$,
                        }"
                    ></ng-container>
                }
            </bazis-step>
        }

        <ng-template
            #entityTemplate
            let-titleEntity="titleEntity"
            let-titleField="titleField"
            let-entityType="entityType"
            let-id="id"
            let-defaultTitle="defaultTitle"
            let-defaultTitleKey="defaultTitleKey"
            let-defaultTitleKeyParam="defaultTitleKeyParam"
            let-isRequired$="isRequired"
        >
            @let entity = id | entity: entityType | async;
            @let isRequired = isRequired$ | async;
            @if (entity) {
                @if (!entity.$snapshot[titleField]) {
                    <span slot="label">
                        {{ defaultTitle || t(defaultTitleKey, defaultTitleKeyParam) }}
                    </span>
                    @if (isRequired) {
                        <span
                            color="danger"
                            class="bazis-text_major"
                            >*</span
                        >
                    }
                }

                @if (entity.$snapshot[titleField] && !titleEntity) {
                    <span slot="label">
                        {{
                            entity.$snapshot[titleField] ||
                                defaultTitle ||
                                t(defaultTitleKey, defaultTitleKeyParam)
                        }}
                    </span>
                    @if (isRequired) {
                        <span
                            color="danger"
                            class="bazis-text_major"
                            >*</span
                        >
                    }
                }

                @if (entity.$snapshot[titleField] && titleEntity) {
                    <ng-container
                        [ngTemplateOutlet]="entityTemplate"
                        [ngTemplateOutletContext]="{
                            titleEntity: titleEntity.titleEntity,
                            titleField: titleEntity.titleField,
                            entityType: entity.$snapshot[titleField].type,
                            id: entity.$snapshot[titleField].id,
                            defaultTitle: defaultTitle,
                            defaultTitleKey: defaultTitleKey,
                            defaultTitleKeyParam: defaultTitleKeyParam,
                            isRequired$: isRequired$,
                        }"
                    >
                    </ng-container>
                }
            }
        </ng-template>

        @if (!item.title && !item.titleKey && (!item.titleEntity || !item.titleEntity.id)) {
            @if (item.defaultTitle || item.defaultTitleKey) {
                <bazis-step
                    [signHidden]="item.children"
                    [iconSign]="!item.isValid && !item.isEmpty ? 'cross-small' : 'check'"
                    (click)="stepClicked(item)"
                >
                    <span slot="label">
                        {{
                            item.defaultTitle || t(item.defaultTitleKey, item.defaultTitleKeyParam)
                        }}
                    </span>

                    @let isRequired = item.isRequired$ | async;
                    @if (isRequired) {
                        <span
                            color="danger"
                            class="bazis-text_major"
                            >*</span
                        >
                    }
                </bazis-step>
            }
        }
    </ng-template>
</ng-container>
